import { GameState } from "../state";
import { damp } from "../../core/math";

// Advance particles, floating text, beams, screen shake, and timed pulses.
export function updateFx(s: GameState, dt: number): void {
  // Particles
  for (const p of s.particles) {
    if (p.life <= 0) continue;
    p.life -= dt;
    p.x += p.vx * dt;
    p.y += p.vy * dt;
    p.vx *= 0.92;
    p.vy *= 0.92;
  }
  if (s.particles.length > 1500) s.particles = s.particles.filter((p) => p.life > 0);

  // Floating text
  for (const f of s.floats) {
    if (f.life <= 0) continue;
    f.life -= dt;
    f.y += f.vy * dt;
    f.vy *= 0.96;
  }
  if (s.floats.length > 300) s.floats = s.floats.filter((f) => f.life > 0);

  // Beams
  for (const b of s.beams) b.life -= dt;
  if (s.beams.length > 300) s.beams = s.beams.filter((b) => b.life > 0);

  // Screen shake decay
  s.shake *= 1 - damp(8, dt);
  if (s.shake < 0.05) s.shake = 0;

  // Damage flash + per-node under-attack pulse decay
  s.damageFlash *= 1 - damp(4, dt);
  if (s.damageFlash < 0.02) s.damageFlash = 0;
  for (const n of s.nodes) {
    if (n.underAttack > 0) n.underAttack -= dt;
  }
}
